module.exports = __webpack_public_path__ + "img/full7-min.d8092103.png";